import { OrderClientPO } from "./OrderClientPO";
import { Invoice } from "../Invoice/Invoice";
import { Address } from "../Address/Address";
import {
  OrderInvoiceStatus,
  OrderPaymentStatus,
  OrderStatus,
} from "./OrderDetails";
import { OrderProduct, OrderServices } from "./OrderProduct";
import { NewUser } from "../User";
import { Customer } from "../Customer/Customer";
import { OrderProfitLossStatement } from "./OrderProfitLossStatement";
import { OrderPaymentLinkDetails } from "./OrderPaymentLinkDetails";

export class OrderRequest {
  order_id?: number;
  type_id?: number;
  type?: string;
  product_id?: number;
  mockup_id?: number;
  selling_price?: number;
  unit_price?: number;
  quantity?: number;
  user_id?: string;
  billing_address_id?: number;
  amount_received?: number;
  shipping_address_id?: number;
  customer_id?: string;
  products?: OrderProductRequest[];
  order_products?: OrderProduct[];
  mockups?: OrderMockupRequest[];
  status?: OrderStatus;
  net_amount: number = 0;
  tax_amount: number = 0;
  amount_before_discount: number = 0;
  discount: number = 0;
  total_amount: number = 0;
  primary_logo_url?: string;
  secondary_logo_url?: string;
  comments?: string;
  client_po_number?: string;
  client_po_url?: string;
  /** Active client POs, oldest first (from order details). */
  client_pos?: OrderClientPO[];
  label?: string;
  admin_id?: number;
  duplicated_from_orderid?: number;
  discount_percentage?: number;
  user_name?: string;
  customer_name?: string;
  order_services?: OrderServices[];
  services?: OrderServices[];
  invoices?: Invoice[];
  billing_address?: Address;
  shipping_address?: Address;
  shipping_amount?: number;
  shipping_amount_tax?: number;
  user?: NewUser;
  customer?: Customer;
  exchange_rate?: number;
  currency?: string;
  proposal_code?: string;
  proposal_url?: string;
  tagged_order_ids?: string;
  is_sez?: number;
  international_order?: number;
  monthly_invoicing?: number;
  gst_percentage?: number;
  size_mix_url?: string;
  bill_from_address_id?: number;
  bill_from_address?: Address;
  profit_loss_statement?: OrderProfitLossStatement;
  payment_links?: OrderPaymentLinkDetails[];
  payment_status?: OrderPaymentStatus;
  invoice_status?: OrderInvoiceStatus;
}

export class OrderProductRequest {
  id?: number;
  quantity: number = 0;
}

export class OrderMockupRequest {
  id?: number;
  product_id?: number;
  image_urls?: string[];
  variant_sku?: string;
  source?: "manual" | "generated";
}
